import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form1" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "panel_left" }
const _hoisted_4 = { class: "image-slot" }
const _hoisted_5 = { class: "panel_right" }
const _hoisted_6 = { class: "example" }
const _hoisted_7 = { class: "media-preview-box" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "video-container"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "video-placeholder"
}
const _hoisted_12 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_VideoPlay = _resolveComponent("VideoPlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              "label-width": "auto",
              style: {"max-width":"600px"},
              "label-position": "top",
              ref: "ruleForm",
              "status-icon": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "标题" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.startTitle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.startTitle) = $event)),
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "内容" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.startContent,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.startContent) = $event)),
                      type: "textarea",
                      size: "large",
                      rows: "10",
                      maxlength: "500",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "展示媒体类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.form.mediaType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.mediaType) = $event)),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_button, { label: "image" }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("图片", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio_button, { label: "video" }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("视频链接", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.form.mediaType === 'image')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "上传图片"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          action: _ctx.UpdateApi,
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          "file-list": _ctx.fileList,
                          disabled: _ctx.allowUpload
                        }, {
                          default: _withCtx(() => [
                            (_ctx.form.startImg)
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  src: _ctx.form.startImg,
                                  class: "avatar",
                                  alt: "",
                                  fit: 'contain'
                                }, {
                                  error: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_icon_picture)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["src"]))
                              : (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 1,
                                  class: "avatar-uploader-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.allowUpload && _ctx.form.mediaType === 'image')
                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          onClick: _ctx.clearImage
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.form.mediaType === 'video')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "视频链接"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.videoLink,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.videoLink) = $event)),
                          placeholder: "请输入视频的嵌入式 URL (例如: https://www.youtube.com/embed/... 或 B站 embed 链接)",
                          size: "large",
                          clearable: ""
                        }, null, 8, ["modelValue"]),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-top":"4px"} }, " * 提示：为了能在 iframe 中正常播放，请确保使用的是支持跨域嵌入的链接（通常带有 /embed/ 或 player 路径）。 ", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "large",
                      style: {"background":"#4f4f4f","color":"#fff","margin-top":"20px"},
                      onClick: _ctx.handleSave
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("保存", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "title" }, "App示意图", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.form.mediaType === 'image')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.form.startImg,
                      alt: "预览图片"
                    }, null, 8, _hoisted_8))
                  : (_ctx.form.mediaType === 'video')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.form.videoLink)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              src: _ctx.form.videoLink,
                              scrolling: "no",
                              border: "0",
                              frameborder: "no",
                              framespacing: "0",
                              allowfullscreen: "true",
                              class: "preview-iframe"
                            }, null, 8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_el_icon, { style: {"font-size":"32px"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VideoPlay)
                                ]),
                                _: 1
                              }),
                              _cache[8] || (_cache[8] = _createElementVNode("p", { style: {"margin-top":"8px","font-size":"13px"} }, "暂无视频链接", -1))
                            ]))
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.form.startTitle), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.form.startContent), 1),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                _createElementVNode("span", null, "继续")
              ], -1))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}